import React, { useRef } from "react";

import DefaultSelect from "components/DefaultSelect";
import { TooltipContainer } from "@outplayed/tooltips";
import { useTranslation } from "react-i18next";

const Season = (props) => {
  const tooltipRef = useRef();
  const { t } = useTranslation();
  const { className, disable, options, filters, onFilterChange, isMobile, disableTooltip } = props;

  if (disable && disable.includes("region")) {
    return null;
  }

  return (
    <TooltipContainer
      ref={tooltipRef}
      tooltipInfo={t("Change Season")}
      customClassName={className}
      disableTooltip={isMobile || disableTooltip}
    >
      <div>
        <DefaultSelect
          title={t("Change Season")}
          isMobile={isMobile}
          className={`filter-select`}
          options={options}
          onChange={(selected) => {
            onFilterChange("season", selected);
          }}
          value={filters.season}
          isSearchable={false}
          width={120}
          onMenuClose={() => tooltipRef.current.forceClose()}
        />
      </div>
    </TooltipContainer>
  );
};

export default Season;
